import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api, useAuth } from '../context/AuthContext';

const TEAM = ['admin', 'kanzlei_mitarbeiter', 'freelancer'];
let gewaehlt = { pfad: '', mnr: '' };

// Formulare (Akonto, Raten, Rechnung, Termin, Eingang) melden hier den Mandanten, an dem gerade gearbeitet wird.
export const setArbeitsMandant = (mnr) => { gewaehlt = { pfad: window.location.pathname, mnr: mnr || '' }; };

const ausUrl = (pathname, search, ansicht) => {
  if (ansicht?.mandanten_nr) return { mandanten_nr: ansicht.mandanten_nr };
  const m = pathname.match(/^\/kanzlei\/mandanten\/(\d+)/) || pathname.match(/^\/team-portal\/m\/(\d+)/);
  if (m) return { mandanten_nr: m[1] };
  const c = pathname.match(/^\/team-portal\/([^/]+)$/);
  if (c && c[1] !== 'm') return { case_id: c[1] };
  const q = new URLSearchParams(search);
  const nr = q.get('mnr') || q.get('vorschlag');
  if (nr) return { mandanten_nr: nr };
  if (gewaehlt.mnr && gewaehlt.pfad === pathname) return { mandanten_nr: gewaehlt.mnr };
  return null;
};

// Zählt jede aktive Minute eines Teammitglieds bei dem Mandanten, an dem es gerade arbeitet (Datenanalyse, Zeitbericht).
export const ArbeitszeitTracker = () => {
  const { echterUser, portalansicht } = useAuth();
  const { pathname, search } = useLocation();
  const ort = useRef({ pathname, search, portalansicht });
  ort.current = { pathname, search, portalansicht };
  const aktiv = TEAM.includes(echterUser?.role);
  useEffect(() => {
    if (!aktiv) return undefined;
    let zuletzt = Date.now();
    const merken = () => { zuletzt = Date.now(); };
    const ev = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];
    ev.forEach((e) => window.addEventListener(e, merken, { passive: true }));
    const t = setInterval(() => {
      const ziel = ausUrl(ort.current.pathname, ort.current.search, ort.current.portalansicht);
      if (ziel && !document.hidden && Date.now() - zuletzt < 120000) api.post('/kanzlei/zeit', ziel).catch(() => {});
    }, 60000);
    return () => { clearInterval(t); ev.forEach((e) => window.removeEventListener(e, merken)); };
  }, [aktiv]);
  return null;
};

export const useArbeitsMandant = (mnr) => {
  useEffect(() => { if (mnr) setArbeitsMandant(mnr); }, [mnr]);
};
